import React, { useState } from "react";
import { useVinDecoder } from "../../hooks/useVinDecoder";
import CFAdminModal from "../../components/CFAdminModal";
import CFAdminDataTable from "../../components/CFAdminDataTable";
import './CFAdminNHTSADecodeVin.scss';

const NHTSAActionsCell = ({ row, column }: any) => {
    return (
        <button onClick={() => column.openModal(row.original)}>
            Show Details
        </button>
    );
};

const StatusCell = ({ row }: any) => {
    return (
        <span style={{ color: row.original.errorCode === '0' ? 'green' : 'red' }}>
            {row.original.errorMessage}
        </span>
    );
};

function CFAdminNHTSADecodeVin() {
    const {
        nhtsaVins,
        nhtsaData,
        nhtsaShowTable,
        handleTextareaChange,
        resetForm,
        decodeVinWithNhtsa,
        downloadCSV,
    } = useVinDecoder();

    const [isOpen, setIsOpen] = useState(false);
    const [selectedRow1, setSelectedRow1] = useState<any>(null);

    const toggleModal = () => {
        setIsOpen(!isOpen);
    };

    const openModal = (row: any) => {
        setSelectedRow1(row);
        setIsOpen(true);
    };

    const closeModal = () => {
        setSelectedRow1(null);
        setIsOpen(false);
    };

    const nhtsaColumns = [
        {
            Header: "VIN",
            accessor: 'vin'
        },
        {
            Header: "Status",
            accessor: 'errorMessage',
            Cell: StatusCell
        },
        {
            Header: "Make",
            accessor: 'make'
        },
        {
            Header: "Model",
            accessor: 'model'
        },
        {
            Header: "Year",
            accessor: 'year'
        },
        {
            Header: "Actions",
            Cell: NHTSAActionsCell,
            openModal: openModal
        }
    ];

    return (
        <>
            <div className="vinimport-component">
                <h2 className="fomo-type--title">Decode VIN - NHTSA </h2>
                <div className="ext3">
                    Please enter the VINs that need to be validated through NHTSA, then click on 'Decode VIN'
                </div>
                {!nhtsaShowTable && (
                    <textarea
                        rows={50}
                        style={{width: "25%", height: "500px", overflowY: "scroll"}}
                        value={nhtsaVins}
                        onChange={handleTextareaChange}
                    />
                )}
                {nhtsaShowTable && (
                    <div className="modal-content-vin">
                        <div style={{width: "75%", overflowX: "auto"}}>
                            <CFAdminDataTable
                                columns={nhtsaColumns}
                                data={nhtsaData}
                                toggleModal={toggleModal}
                                textModal={''}
                                showAdd={false}
                            />
                        </div>
                    </div>
                )}
                <div className="modal-footer button-frame">
                    <button data-testid="step-cancel" className="fvp-button--outline fvp-button"
                            type="submit"
                            onClick={resetForm}>
                        <i className="fvp-left-chevron"/>Cancel
                    </button>
                    <div className="right-align">
                        {!nhtsaShowTable && (
                            <button
                                data-testid="step-release-vin"
                                className="fvp-button button-right-align"
                                type="button"
                                onClick={decodeVinWithNhtsa}
                            >
                                Decode VIN - NHTSA
                            </button>
                        )}
                    </div>
                    {nhtsaShowTable && (
                        <button
                            className="fvp-button button-right-align"
                            type="button"
                            onClick={downloadCSV}
                        >
                            Download CSV  - NHTSA
                        </button>
                    )}
                </div>
            </div>
            {selectedRow1 && (
                <CFAdminModal
                    isOpen={isOpen}
                    toggle={toggleModal}
                    isAdd={false}
                    title={'Vin Decode Results'}
                >
                    <div className="table-container">
                        <table className="table-details">
                            <tbody>
                            <tr>
                                <th>Make</th>
                                <td>{selectedRow1.make}</td>
                            </tr>
                            <tr>
                                <th>Model</th>
                                <td>{selectedRow1.model}</td>
                            </tr>
                            <tr>
                                <th>Year</th>
                                <td>{selectedRow1.year}</td>
                            </tr>
                            <tr>
                                <th>Restraints Driver</th>
                                <td>{selectedRow1.restraintsDriver}</td>
                            </tr>
                            <tr>
                                <th>Cab</th>
                                <td>{selectedRow1.cab}</td>
                            </tr>
                            <tr>
                                <th>Transmission</th>
                                <td>{selectedRow1.transmission}</td>
                            </tr>
                            <tr>
                                <th>Vehicle Type</th>
                                <td>{selectedRow1.vehicleType}</td>
                            </tr>
                            <tr>
                                <th>Engine Displacement</th>
                                <td>{selectedRow1.engineDisplacement}</td>
                            </tr>
                            <tr>
                                <th>Brakes Weight Rating GVWR</th>
                                <td>{selectedRow1.brakesWeightRatingGVWR}</td>
                            </tr>
                            <tr>
                                <th>Series</th>
                                <td>{selectedRow1.series}</td>
                            </tr>
                            <tr>
                                <th>Assembly Country</th>
                                <td>{selectedRow1.assemblyCountry}</td>
                            </tr>
                            <tr>
                                <th>Axle Wheelbase</th>
                                <td>{selectedRow1.axleWheelbase}</td>
                            </tr>
                            <tr>
                                <th>Engine Manufacturer</th>
                                <td>{selectedRow1.engineManufacturer}</td>
                            </tr>
                            <tr>
                                <th>Assembly Plant</th>
                                <td>{selectedRow1.assemblyPlant}</td>
                            </tr>
                            <tr>
                                <th>Body Style</th>
                                <td>{selectedRow1.bodyStyle}</td>
                            </tr>
                            <tr>
                                <th>Fuel</th>
                                <td>{selectedRow1.fuel}</td>
                            </tr>
                            <tr>
                                <th>Brakes Power</th>
                                <td>{selectedRow1.brakesPower}</td>
                            </tr>
                            <tr>
                                <th>Drive Train</th>
                                <td>{selectedRow1.driveTrain}</td>
                            </tr>
                            <tr>
                                <th>Cylinders</th>
                                <td>{selectedRow1.cylinders}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <button onClick={closeModal}>Close</button>
                </CFAdminModal>
            )}
        </>
    );
}

export default CFAdminNHTSADecodeVin;